export default {"src":"/_next/static/media/co-logos-blue.75aaad51.svg","height":34,"width":472,"blurWidth":0,"blurHeight":0};